module.exports = __webpack_public_path__ + "img/magnificentClass.e87f4a39.svg";